import { Button, IconSvg, Size, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import useIsInIframe from 'hooks/store/useIsInIframe';
import * as React from 'react';
import { t } from 'utils/localize';
import DashboardCard, { IDashboardCardProps } from '../DashboardCard/DashboardCard';
import DashboardCardIcon from '../DashboardCardIcon/DashboardCardIcon';
import DashboardCardTextButton from '../DashboardCardTextButton/DashboardCardTextButton';
import DashboardCardTitle from '../DashboardCardTitle/DashboardCardTitle';
import './DashboardEnableCard.scss';

export interface IDashboardEnableCardProps extends Omit<IDashboardCardProps, 'showBlurredBackground'> {
  svg: IconSvg;
  title: string;
  buttonLabel: React.ReactNode;
  onHide?: () => void;
  onClick: (event: React.MouseEvent) => void;
  onLearn?: () => void;
}

function DashboardEnableCard({
  svg,
  title,
  buttonLabel,
  onHide,
  onClick,
  onLearn,
  className,
  theme,
  ...cardProps
}: IDashboardEnableCardProps) {
  const isInIframe = useIsInIframe();
  const classes = classNames('dashboard-enable-card', { 'is-in-iframe': isInIframe }, theme, className);

  function renderLearnMore() {
    return <DashboardCardTextButton onClick={onLearn}>{t('Learn more')}</DashboardCardTextButton>;
  }

  function renderHide() {
    return <DashboardCardTextButton onClick={onHide}>{t('Hide this card')}</DashboardCardTextButton>;
  }

  return (
    <DashboardCard className={classes} theme={theme} showBlurredBackground={theme === Theme.DARK} {...cardProps}>
      <DashboardCardIcon svg={svg} theme={theme} />
      <DashboardCardTitle theme={theme} className="mt-3 mb-6">
        {title}
      </DashboardCardTitle>

      <Button type="primary" onClick={onClick} size={Size.LARGE}>
        {buttonLabel}
      </Button>
      {
        <div className="mt-3">
          {onLearn ? (
            <>
              {renderLearnMore()} | {renderHide()}
            </>
          ) : (
            renderHide()
          )}
        </div>
      }
    </DashboardCard>
  );
}

export default DashboardEnableCard;
